import { render, staticRenderFns } from "./Gradebook.vue?vue&type=template&id=1cc37130"
import script from "./Gradebook.vue?vue&type=script&lang=js"
export * from "./Gradebook.vue?vue&type=script&lang=js"
import style0 from "./Gradebook.vue?vue&type=style&index=0&id=1cc37130&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports